import React, { useState, useEffect } from 'react';
import Modal from 'react-modal';
import { connect } from 'react-redux';
import * as properties from '../../constants/Properties';
import * as resource from '../../constants/Resources';
import CustomerBaseListItem from '../../components/CustomerBaseListItem';
import $ from 'jquery';
import * as general from '../../constants/General';
import { getTranslation } from '../../actions/dataActions';
import { toggleKeyboard } from '../../actions/layoutActions';

function InvoiceCustomerSearchModal(props) {
  const { isOpen, onClose, onSelectCustomer, getTranslation, toggleKeyboard } = props;
  const [data, setData] = useState({ inputField: '', customers: [] });

  function cancelTap() {
    setData({ inputField: '', customers: [] });
    onClose();
  }

  function resetTap() {
    $('#search-invoice-customer').val('');
    setData({ inputField: '', customers: [] });
  }

  function prepareData(description, newCustomers) {
    const wrappedCustomers = Array.isArray(newCustomers)
      ? newCustomers.map(c => (c.Customer ? c : { Customer: c }))
      : [];
    setData({ inputField: description, customers: wrappedCustomers });
  }

  function updateInputFieldAfterSearch(input) {
    fetch(general.API_URL_GET_CUSTOMERS, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        Description: input,
        LabelIDs: []
      })
    })
      .then(result => result.json())
      .then(customers => prepareData(input, customers));
  }

  function showKeyboard() {
    const searchTerm = getTranslation(resource.SEARCH_TERM);
    toggleKeyboard(true, '#search-invoice-customer', searchTerm, updateInputFieldAfterSearch, null, false);
  }

  useEffect(() => {
    if (isOpen) {
      showKeyboard();
    }
  }, [isOpen]);

  function handleCustomerSelect(customer) {
    setData({ inputField: '', customers: [] });
    onSelectCustomer(customer);
    onClose();
  }

  return (
    <Modal
      className="customerBaseModal"
      contentLabel=""
      isOpen={isOpen}
      style={properties.customerBaseModalStyle}
      ariaHideApp={false}
    >
      <div className="customerBaseModal_header">
        <div className="header_top">
          {getTranslation(resource.CUSTOMER_LIST)}
        </div>
      </div>
      <div className="customerBaseModal_content">
        <div>
          <div className="search_bar_div">
            <input
              id="search-invoice-customer"
              className="search_bar"
              placeholder={getTranslation(resource.SEARCH_TERM)}
              onClick={showKeyboard}
              readOnly="readOnly"
              value={data.inputField}
            />
            {data.inputField !== '' &&
              <button className="btnReset" onClick={resetTap} >
                {getTranslation(resource.RESET)}
              </button>
            }
          </div>
          <div className="customerList" >
            {
              data.customers.slice(0, 500)
                .sort((a, b) => {
                  if (!a.Customer || !b.Customer) return 0;
                  if (!a.Customer.Name) return 1;
                  if (!b.Customer.Name) return -1;
                  return a.Customer.Name.localeCompare(b.Customer.Name);
                })
                .map(val =>
                  val.Customer ? (
                    <CustomerBaseListItem
                      key={val.Customer.CustomerId}
                      Customer={val.Customer}
                      Callback={handleCustomerSelect}
                    />
                  ) : null
                )
            }
          </div>
        </div>
      </div>
      <div className="customerBaseModal_footer">
        <button className="btnCancel" onClick={cancelTap} >
          {getTranslation(resource.CANCEL)}
        </button>
      </div>
    </Modal>
  );
}

export default connect(null, {
  getTranslation,
  toggleKeyboard,
})(InvoiceCustomerSearchModal);


// WEBPACK FOOTER //
// src/modal/components/InvoiceCustomerSearchModal.jsx